import { ColorKey } from "./tipos";

/**
 * Background leve (shade-200) para cada cor.
 * Tailwind JIT vai compilar todas essas classes.
 */
export const BG_CLASSES: Record<ColorKey, string> = {
  gray: "bg-gray-200",
  red: "bg-red-200",
  orange: "bg-orange-200", // Manter se 'orange' for usado
  amber: "bg-amber-200",
  green: "bg-green-200",
  emerald: "bg-emerald-200", // Manter se 'emerald' for usado
  teal: "bg-teal-200",
  cyan: "bg-cyan-200",
  blue: "bg-blue-200",
  indigo: "bg-indigo-200",
};

/**
 * Borda média (shade-400) para cada cor.
 */
export const BORDER_CLASSES: Record<ColorKey, string> = {
  gray: "border-gray-400",
  red: "border-red-400",
  orange: "border-orange-400",
  amber: "border-amber-400",
  green: "border-green-400",
  emerald: "border-emerald-400",
  teal: "border-teal-400",
  cyan: "border-cyan-400",
  blue: "border-blue-400",
  indigo: "border-indigo-400",
};

/**
 * Texto escuro (shade-800) para cada cor.
 */
export const TEXT_CLASSES: Record<ColorKey, string> = {
  gray: "text-gray-800",
  red: "text-red-800",
  orange: "text-orange-800",
  amber: "text-amber-800",
  green: "text-green-800",
  emerald: "text-emerald-800",
  teal: "text-teal-800",
  cyan: "text-cyan-800",
  blue: "text-blue-800",
  indigo: "text-indigo-800",
};
